import { useState, useEffect } from 'react';
import { useAd } from '../../context/AdContext';
import { useGameState } from '../../context/GameStateContext';
import { Coins, MessageSquare } from 'lucide-react';
import styles from './TopBar.module.css';
import logoImage from '../../assets/logo_only.png';

const TopBar = ({ onProfileOpen, onFilterOpen, onMessagesOpen, showFilter = true }) => {
  
  // Get window dimensions for responsive adjustments
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  
  // Access contexts
  const { showEarnTokenModalFunc } = useAd();
  const { tokenBalance, unreadMessages } = useGameState();
  
  // Update dimensions on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Determine if we're in portrait mode
  const isPortrait = windowHeight > windowWidth;

  return (
    <div className={styles.topBar} style={{ height: isPortrait ? (windowHeight < 600 ? '36px' : '40px') : '60px' }}>
      <div className={styles.topBarLeft}>
        {/* Logo and app title */}
        <img src={logoImage} alt="GridRank logo" className={styles.logo} />
        <h1 className={styles.appTitle}>GridRank</h1>
      </div>

      <div className={styles.topBarRight}>
        {/* Token balance icon */}
        {tokenBalance !== null && (
          <button
            className={styles.tokenButton}
            onClick={showEarnTokenModalFunc}
            aria-label={`Token balance: ${tokenBalance}`}
          >
            <Coins size={18} />
            <span className={styles.tokenCount}>{tokenBalance}</span>
          </button>
        )}

        {/* Messages/Inbox icon */}
        <button
          className={styles.messagesButton}
          onClick={onMessagesOpen}
          aria-label={unreadMessages > 0 ? `${unreadMessages} unread messages` : 'Open messages'}
        >
          <MessageSquare size={20} />
          {unreadMessages > 0 && (
            <span className={styles.messagesBadge}>{unreadMessages}</span>
          )}
        </button>

        {/* Filter button - Only show when showFilter prop is true */}
        {showFilter && (
          <button
            className={styles.filterButton}
            onClick={onFilterOpen}
            aria-label="Open puzzle filters"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
          </button>
        )}

        <button
          className={styles.profileButton}
          onClick={onProfileOpen}
          aria-label="Open user profile"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TopBar;
